import { withLayouts } from 'react-dx'
import { useRouter } from 'next/router'
import { useLingui } from '@lingui/react/macro'

import RootLayout from '../_layout/layouts/RootLayout'
import AntdLayout from '../_layout/layouts/AntdLayout'
import SiteSpecificContextLayout from '../_layout/layouts/SiteSpecificContextLayout'
import { paddingHeaderHeightCls } from '../_layout/Header/constants'
import LayoutsDefaultLayout from '../_layout'

import { useAiMusicLibraryStore } from './_store'

import type { ListType } from './_store/initialState'
import type { InferGetServerSidePropsType } from 'next'
import type { TNextPagePro } from '@/types/global'

import MusicList from '@/pages/tad.ai/_components/MusicList'
import { getServerSideData } from '@/helpers/server-data'
import { FluentFlex, FluentFlexRoot } from '@/components/FluentFlex'


import { useGlobalAudioPlayer } from '@/hooks/audio/store';
import { useEffect } from 'react';
import { cls } from 'tagged-classnames-free';
import { useConfig } from '@/contexts/SiteContext/hooks';
export const Page: TNextPagePro<
  InferGetServerSidePropsType<typeof getServerSideProps>
> = () => {
  const { collapsed } = useGlobalAudioPlayer()
  const { t } = useLingui()
  const { updateState, listType } = useAiMusicLibraryStore()
  const listTabs: Array<{ label: string; key: ListType }> = [
    {
      label: t`Library`,
      key: 'all',
    },
    {
      label: t`Likes`,
      key: 'liked',
    },
  ]

  const router = useRouter()

  useEffect(() => {
    updateState('listType', 'all')
  }, [updateState])

  return (
    <FluentFlexRoot>
      <FluentFlex className={`min-h-screen ${paddingHeaderHeightCls}`}>
        <FluentFlex
          className={cls`flex-col ${!collapsed && 'pb-32 xl:pb-24'} 3xl:max-w-[1700px] mx-auto xl:max-w-[1080px]`}
        >
          <div className={cls`flex items-center gap-6 px-4 pt-5 md:px-6`}>
            {listTabs.map((tab) => (
              <div
                key={tab.key}
                className={cls`
                  hover:text-f-text cursor-pointer text-lg font-semibold
                   ${listType === tab.key ? 'text-f-text' : 'text-f-text-quaternary'}
                `}
                onClick={() => {
                  updateState('listType', tab.key)
                }}
              >
                {tab.label}
              </div>
            ))}
          </div>
          <MusicList listType={listType} />
        </FluentFlex>
      </FluentFlex>
    </FluentFlexRoot>
  )
}

Page.noPageKey = true

const LayoutsPage = withLayouts(
  Page,
  [
    (props) => {
      return (
        <LayoutsDefaultLayout
          {...props}
          main={{
            className: cls`bg-f-other-1`,
            includingHeader: true,
          }}
          sideBar={{
            className: '',
          }}
          footer={null}
        />
      )
    },
    (props) => {
      const { seoTitle } = useConfig()

      const { t } = useLingui()

      return (
        <RootLayout
          seo={{
            title: seoTitle(
              t`AI Music Library: Explore Generated Songs & Instrumentals`,
            ),
            description: t`Create, save, explore, and download your own AI-generated songs and instrumentals, all in your personal music library.`,
          }}
          {...props}
        />
      )
    },
    (props) => {
      return <SiteSpecificContextLayout {...props} />
    },
    AntdLayout,
  ],
  {
    propertiesHoist: ['noPageKey'],
  },
)

export default LayoutsPage

// eslint-disable-next-line react-refresh/only-export-components
export const getServerSideProps = getServerSideData({
  cacheControl: true,
})(async (_, ctx, helpers) => {})
